// @ts-expect-error
import BaseValidatorSelector from "dot-validator-selector/util/ValidatorSelector";
export * from "./PoolSelector.js";
export { default } from "./PoolSelector.js";
export { defaultOptions } from "./Types.js";
export const ValidatorSelector = BaseValidatorSelector;
